import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Sort = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="sort icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M1.5 6C1.5 5.17157 2.17157 4.5 3 4.5H21C21.8284 4.5 22.5 5.17157 22.5 6C22.5 6.82843 21.8284 7.5 21 7.5H3C2.17157 7.5 1.5 6.82843 1.5 6Z"
    />
    <path
      className={pathClass}
      d="M5.5 12C5.5 11.1716 6.17157 10.5 7 10.5H17C17.8284 10.5 18.5 11.1716 18.5 12C18.5 12.8284 17.8284 13.5 17 13.5H7C6.17157 13.5 5.5 12.8284 5.5 12Z"
    />
    <path
      className={pathClass}
      d="M11 16.5C10.1716 16.5 9.5 17.1716 9.5 18C9.5 18.8284 10.1716 19.5 11 19.5H13C13.8284 19.5 14.5 18.8284 14.5 18C14.5 17.1716 13.8284 16.5 13 16.5H11Z"
    />
  </svg>
)
